import { render, staticRenderFns } from "./reexaminationReview.vue?vue&type=template&id=4ac4e779&scoped=true"
import script from "./reexaminationReview.vue?vue&type=script&lang=js"
export * from "./reexaminationReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac4e779",
  null
  
)

export default component.exports